/**
 * @author NikolaV
 */
import * as React from 'react';


export const Volume = ({ stat }) => <span>{stat.volume} {stat.volumeUnit > 0 ? (stat.volumeUnit == 1 ?
    <span>m<sup>3</sup></span> : kuura.getMessage('trucks.tons')) : null}</span>;

export const Distance = ({ distance }) => <span>{parseFloat((distance / 1000).toFixed(2))} km</span>;
